import React, { FC } from 'react';
import './Video.scss';
import { InteractiveTourProps } from './../InteractiveTourProps';

const Video: FC<InteractiveTourProps> = ({ content }) => {
  return (
    <div className="interactive-tour__slide-video">
      <iframe
        title={content.label.props?.defaultMessage}
        allowFullScreen
        src={content.src.props?.defaultMessage}
      />
    </div>
  );
};

export default Video;
